import { Vue } from 'vue-property-decorator';
import { APPLY_GOOGLE_RECAPTCHA, GOOGLE_RECAPTCHA_BYPASS_COUNTRIES, PROJECT_NAME } from '@/constants';

export const buildConfigWithRecaptchaHeader = (token: string) => ({
  headers: {
    'recaptcha-token': token
  }
});

export function getRecaptchaStatus(residenceCountryCode: string) {
  return APPLY_GOOGLE_RECAPTCHA && !GOOGLE_RECAPTCHA_BYPASS_COUNTRIES.split(',').includes(residenceCountryCode);
}

export const getLoadedRecaptchaToken = (action: string, component: Vue, residenceCountryCode: string): Promise<string> => {
  // dev also need token
  // if (process.env.NODE_ENV === 'development') {
  //   return Promise.resolve('');
  // }
  if (getRecaptchaStatus(residenceCountryCode)) {
    return component.$recaptchaLoaded().then(isLoaded => {
      if (!isLoaded) {
        console.error('Recpatcha not loaded');
        throw new Error();
      }
      return component.$recaptcha(action);
    });
  } else {
    return Promise.resolve('');
  }
};
